// White-label brand config — single source of truth for the identity that
// changes per client. To resell to another agency, change THIS file (+ env
// secrets + the public-site brand points). See docs/white-label.md.

export const BRAND = {
  /** Product/brand name shown in the UI. */
  name: "av/estate",
  /** Wordmark parts (the slash is rendered in the accent color). */
  wordmark: { left: "av", slash: "/", right: "estate" },
  tagline: "Case scelte sul Garda",

  /** Fiscal/legal owner (invoices, footer). */
  legalName: "Alessandro Veneziano",

  /** The agency this instance is operated for. Demo: av/estate stessa —
   *  nessun riferimento ad agenzie o persone reali sul sito pubblico. */
  agency: {
    displayName: "av/estate",
    email: "agenzia@avestate.demo",
    phone: "045 0000000",
    address: "Castelnuovo del Garda (VR)",
  },

  /** Legal/fiscal identity shown on the PUBLIC site (titolare del trattamento,
   *  footer, GDPR page). For the demo this is AVstudio's own entity. */
  legal: {
    piva: "04938450238",
    address: "Via Giotto 3, 37014 Castelnuovo del Garda (VR)",
    addressShort: "Via Giotto 3, Castelnuovo del Garda (VR)",
  },

  /** Public-facing contact shown to site visitors. */
  publicContact: {
    email: "info@avestate.demo",
    phone: "045 0000000",
  },

  /** Outbound links used in the public nav/footer. */
  links: {
    admin: "https://admin.avestate.avstudio.ai",
  },

  /** Accent palette injected into the public-site CSS `:root` at build time.
   *  Change these to recolor the whole public site for a new client. */
  theme: {
    accent: "#4f46e5",
    accentSoft: "#eef2ff",
    accentAlt: "#6366f1",
    accentDark: "#818cf8",
    accentSoftDark: "#1e1b4b",
    accentAltDark: "#a5b4fc",
  },

  /** `<feed source>` value + email subject prefix. */
  feedSource: "avestate",
  /** Footer line appended after the brand name on public pages. */
  footerNote: "gestito da Alessandro Veneziano per la dimostrazione AVstudio",
  /** Same line for the other public locales (EN/DE footers were showing the Italian one). */
  footerNoteI18n: {
    en: "operated by Alessandro Veneziano for the AVstudio demo",
    de: "betrieben von Alessandro Veneziano für die AVstudio-Demo",
  },

  /** Who sells the product (shown in the demo-limit dialog): the vendor, not the demo agency.
   *  phone / bookingUrl are optional: hidden when empty (bookingUrl falls back to the contact form). */
  vendor: {
    name: "AVstudio",
    email: "info@avstudio.ai",
    phone: "",
    bookingUrl: "",
  },

  locales: ["it", "en", "de"] as const,
  defaultLocale: "it" as const,
} as const;

export type Brand = typeof BRAND;
